import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ZuperNavigationItem } from '@zuper/components/zuper-navigation/navigation.types';
import { ZuperNavigationService } from '@zuper/components/zuper-navigation/navigation.service';
import { ZuperVerticalNavigationComponent } from '../../vertical.component';
@Component({
    selector       : 'zuper-vertical-navigation-spacer-item',
    templateUrl    : './spacer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZuperVerticalNavigationSpacerItemComponent implements OnInit, OnDestroy
{
    @Input() item: ZuperNavigationItem;
    @Input() name: string;

    private _zuperVerticalNavigationComponent: ZuperVerticalNavigationComponent;
    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _zuperNavigationService: ZuperNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._zuperVerticalNavigationComponent = this._zuperNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._zuperVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
